import { AdapterFactory } from '../AdapterFactory';

export const adminService = AdapterFactory.getAdminAdapter();
